var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.383 2.401h.358a.239.239 0 0 0 .238-.238.239.239 0 0 0-.238-.238h-.358a.239.239 0 0 0-.238.238c0 .131.108.238.238.238z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.907.282A.474.474 0 0 0 10.48.02h-10A.497.497 0 0 0 .05.282a.474.474 0 0 0 .048.5L4.3 6.068v3.44c0 .179.095.334.25.417.072.036.143.06.226.06.096 0 .19-.024.274-.084l1.322-.916a.728.728 0 0 0 .297-.584V6.056L10.86.782a.474.474 0 0 0 .048-.5zM6.241 5.83a.255.255 0 0 0-.048.143v2.416a.254.254 0 0 1-.095.203l-1.322.916V5.973c0-.084-.035-.155-.095-.19L1.991 2.4h4.321a.239.239 0 0 0 .238-.238.239.239 0 0 0-.238-.238H1.622L.479.497h10L6.24 5.83z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.43e9dcfe0d7ba26e8e856b7d29b8d15c.svg";
export { ForwardRef as ReactComponent };